import type {JobMatchMetaActions} from 'src/action-creators/job-match-meta';
import type {
  JobMatchQueryParam,
  JobMatchSortOption,
  JobMatchSortParam,
  JobMatchCountParam,
} from 'src/types/job-variables';
import {RECEIVE_JOB_MATCH_QUERY_PARAMS} from 'src/action-creators/job-match-meta';


export type JobMatchMetaState = {
  queryParams: JobMatchQueryParam[];
  sortParam: JobMatchSortParam;
  countParam: JobMatchCountParam;
};

const initialState = {
  queryParams: [],
  sortParam: {
    id: '',
    name: '',
    options: [],
  },
  countParam: {
    id: '',
    name: '',
    options: [],
  },
} as const;

export default (
  // @ts-expect-error - TS2322 - Type '{ readonly queryParams: readonly []; readonly sortParam: { readonly id: ""; readonly name: ""; readonly options: readonly []; }; readonly countParam: { readonly id: ""; readonly name: ""; readonly options: readonly []; }; }' is not assignable to type 'JobMatchMetaState'.
  state: JobMatchMetaState | null | undefined = initialState,
  action: JobMatchMetaActions,
): JobMatchMetaState => {
  switch (action.type) {
    case RECEIVE_JOB_MATCH_QUERY_PARAMS: {
      return {
        ...state,
        countParam: action.payload.countParam,
        queryParams: action.payload.queryParams,
        sortParam: action.payload.sortParam,
      };
    }
  }
  // @ts-expect-error - TS2322 - Type 'JobMatchMetaState | null' is not assignable to type 'JobMatchMetaState'.
  return state;
};
